var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('section',{staticClass:"content-box"},[_c('router-link',{staticClass:"d-flex",attrs:{"to":{ name: 'Index' }}},[_c('img',{staticClass:"mb-8",attrs:{"src":"https://dxdq5myzyk6oi.cloudfront.net/august_yale_logos.svg","width":"160","height":"50","alt":"Yale/August"}})]),_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }